import React from 'react';
import { APP_COPY } from '../../constants/copy';
import './footer.scss';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <p className="mb-0">{APP_COPY.footer.copyright}</p>
          </div>
          {/* <div className="col-md-6">
            <ul className="list-inline text-md-end mb-0">
              <li className="list-inline-item">
                <a href="#" className="text-white text-decoration-none">
                  {APP_COPY.footer.links.privacy}
                </a>
              </li>
              <li className="list-inline-item">
                <span className="text-white mx-2">|</span>
              </li>
              <li className="list-inline-item">
                <a href="#" className="text-white text-decoration-none">
                  {APP_COPY.footer.links.terms}
                </a>
              </li>
              <li className="list-inline-item">
                <span className="text-white mx-2">|</span>
              </li>
              <li className="list-inline-item">
                <a href="#" className="text-white text-decoration-none">
                  {APP_COPY.footer.links.sitemap}
                </a>
              </li>
            </ul>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer; 